import Navbar from "../components/site/Navbar";
import Hero from "../components/site/Hero";
import About from "../components/site/About";
import Services from "../components/site/Services";
import Engines from "../components/site/Engines";
import Capabilities from "../components/site/Capabilities";
import Team from "../components/site/Team";
import RFQForm from "../components/site/RFQForm";
import Footer from "../components/site/Footer";

export default function Home() {
  return (
    <div data-testid="home-page" className="bg-white text-[#111827]">
      <Navbar />
      <main>
        <Hero />
        <About />
        <Services />
        <Engines />
        <Capabilities />
        <Team />
        <RFQForm />
      </main>
      <Footer />
    </div>
  );
}
